import { combineReducers } from 'redux'
import AppReducer from './state'
import StockAddressingInBatchReducer from './stock-addressing-in-batch/StockAddressingInBatchState'
import StockListReducer from './stock-list/StockListState'
import StockManagementReducer from './stock-management/StockManagementState'
import StockMovementsReducer from './stock-movements/StockMovementsState'
import StockAdjustmentInBatchReducer from './stock-adjustment-in-batch/StockAdjustmentInBatchState'
import TaxCouponReducer from './tax-coupon/TaxCouponState'
import ReceivementReducer from './receivement/ReceivementState'
import FractionReducer from './fraction/FractionState'
import DanfeReducer from '../components/Danfe/danfeState'
import PendingReceivementsReducer from './pending-receivements/PendingReceivementsState'
import SupplierReducer from './supplier/SupplierState'
import ReceivementOverviewListReducer from './receivement-overview-list/ReceivementOverviewListState'
import BasicQueryReducer from './basic-queries/BasicQueriesState'
import DockManagementReducer from './dock-management/DockManagementState'
import LossReducer from './loss/LossState'
import EmailSettingsReducer from './email-settings/EmailSettingsState'
import RestockingReducer from './restocking/RestockingState'
import DivergenceDemandsReducer from './divergence-demands/DivergenceDemandsState'
import InventoryReducer from './inventory/InventoryState'
import ShedManagementReducer from './shed-management/ShedManagementState'
import SwapOrReturnReducer from './swap-or-return/SwapOrReturnState'
import PrintersManagementReducer from './settings/printers-management/PrintersManagementState'
import TransfersReducer from './transfers/TransfersState'

export default combineReducers({
  app: AppReducer,
  stockList: StockListReducer,
  stockManagement: StockManagementReducer,
  stockMovements: StockMovementsReducer,
  stockAdjustmentInBatch: StockAdjustmentInBatchReducer,
  stockAddressingInBatch: StockAddressingInBatchReducer,
  taxCoupon: TaxCouponReducer,
  receivement: ReceivementReducer,
  fraction: FractionReducer,
  danfe: DanfeReducer,
  pendingReceivements: PendingReceivementsReducer,
  supplier: SupplierReducer,
  receivementOverviewList: ReceivementOverviewListReducer,
  basicQuery: BasicQueryReducer,
  dockManagement: DockManagementReducer,
  loss: LossReducer,
  emailSettings: EmailSettingsReducer,
  restocking: RestockingReducer,
  divergenceDemands: DivergenceDemandsReducer,
  inventory: InventoryReducer,
  shedManagement: ShedManagementReducer,
  swapOrReturn: SwapOrReturnReducer,
  printersManagement: PrintersManagementReducer,
  transfers: TransfersReducer,
})
